import { ExamEventPermissionRoute } from '@exam-center/exam-event-management';
import { useParams } from '@exam-center/router';
import { dayjs } from '@shared/utils';

export default function ExamEventsPage() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-events');
  const currentYear = dayjs().year().toString();

  return <ExamEventPermissionRoute examCenterCode={examCenterCode} currentYear={currentYear} />;
}
